import { render, staticRenderFns } from "./DataLayerValue.vue?vue&type=template&id=aabb718c&"
import script from "./DataLayerValue.vue?vue&type=script&lang=js&"
export * from "./DataLayerValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aabb718c')) {
      api.createRecord('aabb718c', component.options)
    } else {
      api.reload('aabb718c', component.options)
    }
    module.hot.accept("./DataLayerValue.vue?vue&type=template&id=aabb718c&", function () {
      api.rerender('aabb718c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/datalayers/DataLayerValue.vue"
export default component.exports